import {
    useState,
    useEffect,
    useContext,
    createContext,
    useCallback
} from "react";
import { useParams } from "react-router-dom";

import Forms from "../../../services/forms";

const SharedSectionContext = createContext({});

export function SharedSectionProvider({ children }) {
    const { id: deploymentId } = useParams();

    const [sharedSection, setSharedSection] = useState(null);
    const [sharedSectionNames, setSharedSectionNames] = useState([]);

    const refreshSharedSectionNames = useCallback(() => {
        Forms.getSharedSections({ deploymentId }).then((res) => {
            if (!res.error && res.data) {
                setSharedSectionNames(res.data.map(({ name }) => name));
            }
        });
    }, [deploymentId]);

    useEffect(() => {
        if (deploymentId) {
            refreshSharedSectionNames();
        }
    }, [deploymentId, refreshSharedSectionNames, sharedSection]);

    const updateSharedSection = (newSharedSection) => {
        setSharedSection({ ...newSharedSection });
    };

    return (
        <SharedSectionContext.Provider
            value={{
                sharedSection,
                setSharedSection: updateSharedSection,
                sharedSectionNames,
                refreshSharedSectionNames
            }}
        >
            {children}
        </SharedSectionContext.Provider>
    );
}

export function useSharedSection() {
    return useContext(SharedSectionContext);
}
